<script>

import Layout from "../../layouts/auth";
import {
  //authMethods,
  //authFackMethods,
  notificationMethods,
  authWellyMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
//import { apiAuth }  from "../../../constants"

/**
 * Login component
 */
 function customEmail(value) {
  if (!value) return true;
  const re = /^[\p{L}0-9._%+-]+@[\p{L}0-9.-]+\.[a-zA-Z]{2,}$/u;
  return re.test(value);
}


export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      showSpinner: false,
      passwordFieldVisible: false,
      passwordFieldType: 'password'
    };
  },
  validations: {
    email: {
      required,
      customEmail,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    //...authMethods,
    //...authFackMethods,
    ...authWellyMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    async tryToLogIn() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } 
      else {
        this.showSpinner = true
          const { email, password } = this;
          if (email && password) {
            try {
              await this.login({
                 email,
                 password,
               })
               this.showSpinner = false
             }
             catch {
              this.showSpinner = false
             }

            }
      }
    },
    togglePasswordVisibility() {
      this.passwordFieldVisible = !this.passwordFieldVisible;
      this.passwordFieldType = this.passwordFieldVisible ? 'text' : 'password';
    }
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-sm-1 col-md-1 col-lg-1">
      </div>
      <div class="col-sm-10 col-md-10 col-lg-10">
        <div>
          <div>
            <br/><br/><br/>

            <div class="row">
              <div class="col-lg-12 center"> 
                <router-link tag="a" to="/">
                  <img src="@/assets/images/logo.gif" alt height="60" />
                </router-link>
              </div>

              <div class="col-lg-12 center"> 
                <span><b class="green">Welly Go </b></span>
                <span><b class="orange">RESTÓ</b></span>
              </div>
            </div>

            <br/>

            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >
            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3 green"
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  class="btn-outline"
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Ingrese email"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email es requerido.</span>
                  <span v-if="!$v.email.customEmail">Por favor ingrese un email válido.</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3 green"
                id="input-group-2"
                label="Contraseña"
                label-for="input-2"
              >
                <div class="input-group">
                  <b-form-input
                    class="btn-outline"
                    id="input-2"
                    v-model="password"
                    :type="passwordFieldType"
                    placeholder="Ingrese contraseña"
                    :class="{ 'is-invalid': submitted && $v.password.$error }"
                  ></b-form-input>
                  <div class="input-group-append">
                    <span @click="togglePasswordVisibility" class="input-group-text password-toggle icon-password">
                      <i :class="passwordFieldVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </span>
                  </div>
                </div>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Contraseña es requerida.
                </div>
              </b-form-group>
              <!--
              <b-form-checkbox
                  class="form-check"
                  id="customControlInline"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  Recordarme
              </b-form-checkbox>
              -->
              <br/>
              <div class="center">
                  <!-- :disabled="showSpinner" -->
                <b-button type="submit" variant="success" class="btn-width" :disabled="showSpinner"
                  >Iniciar sesión
                  <b-spinner class="float-right" label="Floated Right" small v-show="showSpinner"></b-spinner>
                  </b-button>
              </div>
              <!--
              <div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Sign in with</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-success text-white border-success"
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-danger text-white border-danger"
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div>
              -->
              <!-- 
              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i>
                </router-link>
              </div>
              -->
            </b-form>
            <br/><br/><br/><br/>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <!--
        <div class="mt-5 text-center">
          <p>
            Don't have an account ?
            <router-link
              tag="a"
              to="/register"
              class="fw-medium text-success"
              >Signup now</router-link
            >
          </p>
          <p>
            © {{ new Date().getFullYear() }} Skote. Crafted with
            <i class="mdi mdi-heart text-danger"></i> by Themesbrand
          </p>
        </div>
        -->
        <!-- end row -->
      </div>
      <div class="col-sm-1 col-md-1 col-lg-1">
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.green {
    color: #2DA673;
}

.orange {
    color: #EE6C3F;
}

.center {
   text-align: center;
}

.btn-width {
    text-align: center;
    width: 60%;
}

.btn-outline {
    outline: none;
    border: 0;
    border-bottom: 1px solid #000;
    border-radius: 0%;
    background: none;
}

.float-right{
  float: right;
}

.icon-password{
  border: none;
  background-color: #e8f0fe;
  color: #2DA673;
  height: 2.2rem;
  border-bottom: 1px solid #000;
  border-radius: 0;
}

</style>
